export default __webpack_public_path__ + "static/media/storyreveal.4acc7a50.mp3";